var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.sign()}}},[_vm._v(_vm._s(_vm.$t("requests.sign_contract")))]),_c('ECPSigner',{ref:"ecpSingerRef",attrs:{"title":_vm.$t('eds.sign-with-eds')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }